/** A headline number on the Today screen. */
export function Kpi({ label, value, sub, loading, failed, alert, href }: {
  label: string; value: number | undefined; sub?: string; loading: boolean; failed: boolean; alert?: boolean; href?: string;
}) {
  const body = (
    <>
      <span className="kpi__label">{label}</span>
      <span className="kpi__value">{loading ? <span className="skeleton skeleton--kpi" /> : failed ? <span className="kpi__na">Unavailable</span> : value}</span>
      {sub && !loading && <span className="kpi__sub">{sub}</span>}
    </>
  );
  const cls = `kpi${alert ? " kpi--alert" : ""}${alert && value ? " kpi--hot" : ""}`;
  return href ? <a className={`${cls} kpi--link`} href={href}>{body}</a> : <div className={cls}>{body}</div>;
}
